import React, { Fragment, useEffect, useState } from 'react';
import { ArrowDown, ArrowUp, ChevronDown, ChevronUp } from 'react-feather';
import { useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import { numberFormater, sortTypes } from '../../helpers/common';
import { colors, dataPoints } from '../../helpers/meta';
import ColorDot from '../ColorDot';
import { Link } from 'react-router-dom';

const SummaryTable = ({ dataOptions }) => {
    const dataPoints = {};
    dataOptions.forEach(val => {
        dataPoints[val.value] = val.label;
    });

    console.log('dataPoints',dataPoints);


    const summary = useSelector(state => state.summary);
    const [sortBy, setSortBy] = useState(Object.keys(dataPoints)[0]);
    const [sortDir, setSortDir] = useState(sortTypes.DESC);
    const [sorted, setSorted] = useState([]);
    console.log('summary',summary);
    console.log('sorted',sorted);
    const setSelection = (key) => {
        if (key != sortBy) {
            setSortBy(key);
            setSortDir(sortTypes.DESC);
        } else {
            setSortDir(sortDir == sortTypes.DESC ? sortTypes.ASC : sortTypes.DESC);
        }
    }

    useEffect(() => {
        if (summary.current && summary.current.length) {
            try {
                var _current = summary.current.slice();
                var _previous = summary.previous.slice();
                _current = _current.map((val, index) => {
                    return { ...val, previous: (_previous.filter((a) => a._id == val._id))[0] };
                });
                var _sorted = [];
                if (sortDir == "DESC") {
                    _sorted = _current.sort((a, b) => b[sortBy] - a[sortBy]);
                } else {
                    _sorted = _current.sort((a, b) => a[sortBy] - b[sortBy]);
                }
                setSorted(_sorted);
            } catch (e) {
                console.log(e)
            }
        }
    }, [summary, sortBy, sortDir])
    return (
        <Fragment>
            <Table bordered style={{ fontSize: "14px", textAlign: "center" }}>
                <thead>
                    <tr>
                        {/* <th style={{width: "50px"}}>Status</th> */}
                        <th className='pointer' style={{ textAlign: "left", maxWidth: "350px", width: "300px" }}>Store Name</th>
                        {
                            Object.keys(dataPoints).map((key, index) => {
                                return <th className='pointer select-none' style={{ width: "70px", paddingLeft: "1rem" }} onClick={() => setSelection(key)} key={"main-table-th-" + index}>{sortBy == key && (sortDir == sortTypes.DESC ? <ChevronDown size={16} style={{ position: "absolute", marginTop: "2px", marginLeft: "-15px", color: colors.primary }} /> : <ChevronUp size={16} style={{ position: "absolute", marginTop: "2px", marginLeft: "-15px", color: colors.primary }} />)} {dataPoints[key]}</th>
                            })
                        }
                    </tr>
                </thead>
                <tbody style={{ borderTop: "none" }}>
                    {
                        sorted && sorted.length > 0 &&
                        sorted.map((row, index) => {    
                          
                            return <tr key={"main-table-" + index}>
                                {/* <td style={{textAlign: "left"}}><ColorDot position='absolute' color={Math.random() < 0.4 ? colors.success : Math.random() < 0.7 ? colors.primary : colors.silver}/><span style={{marginLeft: "20px"}}>{row.label}</span></td> */}
                                <td style={{ textAlign: "left" }}><ColorDot position='absolute' color={colors.success} /><span style={{ marginLeft: "20px" }}><Link to={"/conversions/"+row._id+"/"+row.label}>{row.label}</Link></span></td>
                                {
                                    Object.keys(dataPoints).map((key, index) => {
                                        return <td key={"main-table-td-" + index}>{numberFormater(row[key])}</td>
                                    })
                                }
                            </tr>
                        })
                    }
                </tbody>
            </Table>
        </Fragment>
    )
}

export default SummaryTable;